import React from 'react';
import { LogoWithText } from './Logo';

export const Footer = ({ t }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center md:items-start gap-3">
            <LogoWithText />
            <p className="text-gray-400 text-sm max-w-md text-center md:text-left">
              {t.footer.tagline}
            </p>
          </div>

          <div className="text-center md:text-right">
            <p className="text-gray-400 text-sm">
              © {currentYear} Valtellina Software. {t.footer.rights}
            </p>
            <a 
              href="mailto:info@valtellina-software.ch"
              className="text-blue-400 hover:text-blue-300 transition-colors text-sm mt-2 inline-block"
            >
              info@valtellina-software.ch
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
